import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NcdclientService } from 'src/app/services/NCD/ncdclient.service';

declare var $: any;
import * as _ from 'lodash';
import { AlertComponent } from '../../alert/alert.component';
@Component({
  selector: 'app-additional-fields-tab',
  templateUrl: './additional-fields-tab.component.html',
  styleUrls: ['./additional-fields-tab.component.css']
})
export class AdditionalFieldsTabComponent implements OnInit {

  @Input('issueDetails') issueDetails: any;

  additionalFieldsForm: FormGroup;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  disabledOnClick: boolean = false;

  constructor(private ncdClientService: NcdclientService, private alert: AlertComponent, 
    private fb: FormBuilder, private router: Router) { }


  ngOnInit() {
    this.additionalFieldsForm = new FormGroup({
      ChargeID: new FormControl('', []),
      ListingDate: new FormControl('', []),
      dynamicFieldsArray: this.fb.array([this.debenturesAndDrawnAmountDynamicFormGroup()]),
      AggregateAmount: new FormControl('', []),
    });

    var resData = this.issueDetails
    this.getAdditionalFields(resData);
  }

  debenturesAndDrawnAmountDynamicFormGroup(): FormGroup {
    return this.fb.group({
      NumberOfDebenturesIssued: ['', [Validators.required]],
      DrawnAmount: ['', [Validators.required]],
      isinNO: ['', [Validators.required]],
      scripCode: ['', [Validators.required]],
      dateOfCorporateAction: ['', [Validators.required]],
    });
  }

  addNewFieldsBlock() {
    (<FormArray>this.additionalFieldsForm.get('dynamicFieldsArray')).push(this.debenturesAndDrawnAmountDynamicFormGroup());
  }

  checkIsinNoValid(ev, i) {
    if (ev.target.value.length != 12) {
      $("#isIsinNoValid" + i).text("ISIN No. must be of exact 12 Digits").show();
    }
    else {
      $("#isIsinNoValid" + i).text("").show();
    }
  }

  getAdditionalFields(resData) {
    var addTabsDetails = resData;

    // Removing all dynamic controls
    const formArrayNewField: FormArray = <FormArray>this.additionalFieldsForm.get('dynamicFieldsArray');
    while (formArrayNewField.length !== 0) {
      formArrayNewField.controls = [];
    }

    var count = 0;
    var self = this;
    _.forEach(resData.AdditionalFields.dynamicFieldsArray, function (debenturesAndDrawnAmount) {
      const formArray: FormArray = <FormArray>self.additionalFieldsForm.get('dynamicFieldsArray');
      formArray.push(self.debenturesAndDrawnAmountDynamicFormGroup());
      var formGroup: FormGroup = <FormGroup>formArray.controls[count];

      var DateOfCorporateAction = null;
      if ((debenturesAndDrawnAmount.dateOfCorporateAction != undefined || debenturesAndDrawnAmount.dateOfCorporateAction != null)) {
        DateOfCorporateAction = { year: new Date(debenturesAndDrawnAmount.dateOfCorporateAction).getFullYear(), month: new Date(debenturesAndDrawnAmount.dateOfCorporateAction).getMonth() + 1, day: new Date(debenturesAndDrawnAmount.dateOfCorporateAction).getDate() };
      }

      formGroup.controls.NumberOfDebenturesIssued.setValue(debenturesAndDrawnAmount.NumberOfDebenturesIssued);
      formGroup.controls.DrawnAmount.setValue(debenturesAndDrawnAmount.DrawnAmount);
      formGroup.controls.isinNO.setValue(debenturesAndDrawnAmount.isinNO);
      formGroup.controls.scripCode.setValue(debenturesAndDrawnAmount.scripCode);
      formGroup.controls.dateOfCorporateAction.setValue(DateOfCorporateAction);

      formGroup.controls.NumberOfDebenturesIssued.updateValueAndValidity()
      formGroup.controls.DrawnAmount.updateValueAndValidity()
      formGroup.controls.isinNO.updateValueAndValidity()
      formGroup.controls.scripCode.updateValueAndValidity()
      formGroup.controls.dateOfCorporateAction.updateValueAndValidity()

      count++;
    })


    if (resData.AdditionalFields.dynamicFieldsArray.length < resData.MultiOption.length) {
      var remainingdynamicCount = resData.MultiOption.length - resData.AdditionalFields.dynamicFieldsArray.length;
      for (let i = 0; i < remainingdynamicCount; i++) {
        this.addNewFieldsBlock();
      }
    }

    var listingDate = null;
    if (addTabsDetails.AdditionalFields.ListingDate != undefined || addTabsDetails.AdditionalFields.ListingDate != null) {
      listingDate = { year: new Date(addTabsDetails.AdditionalFields.ListingDate).getFullYear(), month: new Date(addTabsDetails.AdditionalFields.ListingDate).getMonth() + 1, day: new Date(addTabsDetails.AdditionalFields.ListingDate).getDate() };
    }

    var AggregateAmount = 0;
    if (addTabsDetails.OptionToRetainOversubscription != null && addTabsDetails.IssueSize != null) {
      AggregateAmount = Number((addTabsDetails.OptionToRetainOversubscription).replace(/[Crs,]/g, "")) + Number((addTabsDetails.IssueSize).replace(/[Crs,]/g, ""));
    }

    this.additionalFieldsForm.patchValue({
      ChargeID: addTabsDetails.AdditionalFields.ChargeID,
      ListingDate: listingDate,
      AggregateAmount: this.addCommas(AggregateAmount) + " Crs",
    })

  }

  addAdditionalFields() {
    this.disabledOnClick = true;
    // if (this.additionalFieldsForm.status == "VALID") {
    var dynamicArray = this.additionalFieldsForm.value.dynamicFieldsArray;
    var self = this;
    dynamicArray.forEach(function (elem) {
      if (elem.dateOfCorporateAction != null) {
        elem.dateOfCorporateAction = self.setDate(elem.dateOfCorporateAction);
      }
    })

    var additionalFieldsFormData = {
      "additionalFields":
      {
        imDate: this.setDate(this.issueDetails.AdditionalFields.imDate),
        CreditRatingLetterDate_1: this.setDate(this.issueDetails.AdditionalFields.CreditRatingLetterDate_1),
        CreditRatingLetterAmount_1: this.issueDetails.AdditionalFields.CreditRatingLetterAmount_1,
        CreditRatingLetterDate_2: this.setDate(this.issueDetails.AdditionalFields.CreditRatingLetterDate_2),
        CreditRatingLetterAmount_2: this.issueDetails.AdditionalFields.CreditRatingLetterAmount_2,
        CreditRatingLetterDate_3: this.setDate(this.issueDetails.AdditionalFields.CreditRatingLetterDate_3),
        CreditRatingLetterAmount_3: this.issueDetails.AdditionalFields.CreditRatingLetterAmount_3,
        CreditRatingLetterDate_4: this.setDate(this.issueDetails.AdditionalFields.CreditRatingLetterDate_4),
        CreditRatingLetterAmount_4: this.issueDetails.AdditionalFields.CreditRatingLetterAmount_4,
        ListingDate: this.setDate(this.additionalFieldsForm.value.ListingDate),
        DebentureTrusteeAgreementDate: this.setDate(this.issueDetails.AdditionalFields.DebentureTrusteeAgreementDate),
        DeedOfHypothecationDate: this.setDate(this.issueDetails.AdditionalFields.DeedOfHypothecationDate),
        SimpleMortgateDeedNumber: this.issueDetails.AdditionalFields.SimpleMortgateDeedNumber,
        SimpleMortgateDeedDate: this.setDate(this.issueDetails.AdditionalFields.SimpleMortgateDeedDate),
        DebentureTrusteeConsentNumber: this.issueDetails.AdditionalFields.DebentureTrusteeConsentNumber,
        DebentureTrusteeConsentDate: this.setDate(this.issueDetails.AdditionalFields.DebentureTrusteeConsentDate),
        PropertyDescription: this.issueDetails.AdditionalFields.PropertyDescription,
        ChargeID: this.additionalFieldsForm.value.ChargeID,
        DateOfSigningApprovalLetter: this.setDate(this.issueDetails.AdditionalFields.DateOfSigningApprovalLetter),
        DateOfIntimationToStockExchange: this.setDate(this.issueDetails.AdditionalFields.DateOfIntimationToStockExchange),
        AllotmentLetterDate: this.setDate(this.issueDetails.AdditionalFields.AllotmentLetterDate),
        DateOfMasterCreationFormCDSL_NSDL: this.setDate(this.issueDetails.AdditionalFields.DateOfMasterCreationFormCDSL_NSDL),
        DebentureTrustDeedDate: this.setDate(this.issueDetails.AdditionalFields.DebentureTrustDeedDate),
        AggregateAmount: this.additionalFieldsForm.value.AggregateAmount,
        dynamicFieldsArray: dynamicArray,
      }
    }
    this.ncdClientService.addAdditionalFields(additionalFieldsFormData, this.issueDetails._id)
      .subscribe((res:any) => {
        this.disabledOnClick = false;
        if (res.status == 0) {
          this.alert.successWithOk(res.message, '/ncd-issue/edit/' + res.data._id)
        }
        else {
          if (res.errFields) {
            this.alert.error(JSON.stringify(res.errFields) + ' fields are required');
          } else if (res.error) {
            this.alert.error(JSON.stringify(res.error) + ' fields are required');
          } else {
            this.alert.error(res.message);
          }
        }
      });
    // }


  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  addCommas(nStr) {
    nStr += '';
    var x = nStr.split('.');
    var x1 = x[0];
    var x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }


  calculateDrawnAmount(event, i, MultiOption) {
    var noOfDeb = event.target.value;
    var calculatedDrawnAmount
    if (noOfDeb != '' || noOfDeb != undefined) {
      calculatedDrawnAmount = this.addCommas(MultiOption.faceValue.replace(/\,/g, "") * noOfDeb.replace(/\,/g, ""))
    } else {
      calculatedDrawnAmount = 0;
    }


    this.additionalFieldsForm.controls.dynamicFieldsArray['controls'][i].controls.DrawnAmount.setValue(calculatedDrawnAmount);

    // this.additionalFieldsForm.patchValue({
    //   DrawnAmount: this.addCommas(this.convertAmountToInteger(this.issueDetails.FaceValue) * this.convertAmountToInteger(noOfDeb))
    // });
  }

}

